<template>
  <v-row>
    <v-col cols="12">
      <v-dialog
        v-model="dialog"
        persistent
        max-width="480px"
        :retain-focus="false"
      >
        <v-card>
          <v-form ref="form" lazy-validation>
            <v-card-title class="d-flex justify-space-between">
              <div>Application Details</div>
              <div class="ml-auto d-flex" v-if="actionType === 'confirm'">
                <v-btn color="primary" x-small  @click.prevent="showNextCalldate">
                  <v-icon class="mr-2" x-small>mdi-phone</v-icon> Next Call
                  Date
                </v-btn>
              </div>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-simple-table>
                      <template v-slot:default>
                        <!-- <thead>
                          <tr>
                            <th class="text-left">
                              Name
                            </th>
                            <th class="text-left">
                              Calories
                            </th>
                          </tr>
                        </thead> -->
                        <tbody>
                          <!-- <tr v-for="item in desserts" :key="item.name">
                            <td>{{ item.name }}</td>
                            <td>{{ item.calories }}</td>
                          </tr> -->
                          <tr>
                            <th>Name</th>
                            <td>
                              {{ selectedData.firstName }}
                              {{ selectedData.lastName }}
                            </td>
                          </tr>
                          <tr>
                            <th>Mobile Number</th>
                            <td>{{ selectedData.mobileNumber }}</td>
                          </tr>
                          <tr>
                            <th>Email</th>
                            <td>{{ selectedData.emailAddress }}</td>
                          </tr>

                          <tr>
                            <th>Barangay</th>
                            <td>{{ selectedData.barangay }}</td>
                          </tr>
                          <tr>
                            <th>City</th>
                            <td>{{ selectedData.city }}</td>
                          </tr>
                          <tr>
                            <th>Province</th>
                            <td>{{ selectedData.province }}</td>
                          </tr>
                          <tr>
                            <th>Distributor</th>
                            <td>{{ selectedData.codDistributor.name }}</td>
                          </tr>
                          
                          <tr v-if="selectedData.sku">
                            <th>Data Pack</th>
                            <td>
                              {{ selectedData.sku.skuName }} -
                              {{ selectedData.sku.price }}
                            </td>
                          </tr>

                          <tr v-if="actionType == 'installed'">
                            <th>Date Applied</th>
                            <td>
                              {{ formatDate(selectedData.createdDate) }}
                            </td>
                          </tr>
                          <tr v-if="actionType == 'installed'">
                            <th>Activation Date</th>
                            <td>
                              {{ formatDate(selectedData.activationDate) }}
                            </td>
                          </tr>
                          <tr v-if="actionType == 'installed'">
                            <th>Duration</th>
                            <td>
                              {{
                                duration(
                                  selectedData.createdDate,
                                  selectedData.activationDate
                                )
                              }}
                            </td>
                          </tr>
                          <tr v-if="actionType == 'cancelled'">
                            <th>Reason of Cancellation</th>
                            <td>
                              {{ selectedData.codReason }}
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                  <!-- <v-col cols="12" class="mt-0 pt-0">
                    <v-select
                      label="Select Status"
                      :items="dispatchStatus"
                      v-model="form.status"
                      :rules="rules.required"
                    >
                    </v-select>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-select
                      label="Select Assign To"
                      :items="assignToList"
                      v-model="form.assignedTo"
                      :rules="rules.required"
                    >
                    </v-select>
                  </v-col> -->
                  <v-col
                    cols="7"
                    class="mt-0 pt-0"
                    v-if="
                      actionType != 'installed' &&
                      actionType != 'cancelled' &&
                      actionType != 'paid'
                    "
                  >
                    <v-text-field
                      type="date"
                      name="installationDate"
                      :max="maxDate"
                      :min="minDate"
                      v-model="installationDate"
                      label="Installation Date"
                      :rules="rules.required"
                      @keydown.prevent="returnFalse()"
                    />
                  </v-col>
                  <v-col
                    cols="5"
                    class="mt-0 pt-0"
                    v-if="
                      actionType != 'installed' &&
                      actionType != 'cancelled' &&
                      actionType != 'paid'
                    "
                  >
                    <v-text-field
                      type="time"
                      name="installationDate"
                      v-model="installationTime"
                      label="Installation Time"
                      :rules="rules.required"
                    />
                  </v-col>
                </v-row>
              </v-container>
              <!-- <small>*indicates required field</small> -->
            </v-card-text>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn link :disabled="loadingBtn" text @click.native="cancel">
                Close
              </v-btn>

              <v-btn
                color="error"
                :loading="loadingBtn"
                :disabled="loadingBtn"
                @click.prevent="onCancel()"
                v-if="actionType != 'installed' && actionType != 'cancelled'"
                class="px-10"
              >
                Cancel
              </v-btn>
              <v-btn
                v-if="actionType === 'confirm'"
                color="primary"
                :loading="loadingBtn"
                :disabled="loadingBtn"
                @click.prevent="onSubmit()"
                class="px-10"
              >
                Confirm
              </v-btn>

              <v-btn
                v-if="actionType === 'past-due'"
                color="primary"
                :loading="loadingBtn"
                :disabled="loadingBtn"
                @click.prevent="pastDue()"
                class="px-10"
              >
                Confirm
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-col>
    <Snackbar></Snackbar>
    <confirmation-diaglog ref="confirm"></confirmation-diaglog>
    <cod-cancellation-dialog ref="codCancel"></cod-cancellation-dialog>
    <next-call-date ref="nextCallDate"></next-call-date>
  </v-row>
</template>

<script>
// import moment from "moment";
import Snackbar from "../Snackbar.vue";
import ShareableMethods from "@/mixins/ShareableMethods";
import ConfirmationDiaglog from "../ConfirmationDiaglogv2.vue";
import CodCancellationDialog from "./CodCancellationDialog.vue";
import NextCallDate from './NextCallDate.vue'
import moment from "moment";

export default {
  mixins: [ShareableMethods],
  name: "OnlineApplicationDialog",

  components: {
    Snackbar,
    ConfirmationDiaglog,
    CodCancellationDialog,
    NextCallDate
  },
  data() {
    return {
      dates: "",
      menu: false,
      modal: false,

      dispatchStatus: [],
      assignToList: [],

      dialog: false,
      resolve: null,
      reject: null,

      selectedData: null,

      loadingBtn: false,
      rules: {
        required: [(value) => !!value || "Required."],
      },

      form: {
        referenceNumber: "",
        installationDate: "",
      },

      installationDate: "",
      installationTime: "",
      maxDate: "",
      minDate: "",
      actionType: "",
    };
  },

  methods: {
    duration(start, end) {
      // console.log(start, end);
      const date1 = moment(new Date(start)).format("YYYY-DD-MM"); //todays date
      const date2 = moment(new Date(end)).format("YYYY-DD-MM"); // another date

      const newDate1 = moment(date1, "YYYY-DD-MM", true);
      const newDate2 = moment(date2, "YYYY-DD-MM", true);
      let totalDays = newDate2.diff(newDate1, "days");
      return `${totalDays} ${totalDays > 1 ? "days" : "day"}`;
    },

    returnFalse() {
      return false;
    },

    open(data, type) {
      console.log(data);
      this.actionType = type;
      this.dialog = true;
      this.form.referenceNumber = data.referenceNumber;

      this.selectedData = data;

      if (data?.installationDate) {
        const installationDate = data?.installationDate.split(" ");
        this.installationDate = installationDate[0];
        this.installationTime = installationDate[1];
      }

      // console.log(insta')

      this.maxDate = moment().add(3, "days").format("YYYY-MM-DD");

      this.minDate = moment().format("YYYY-MM-DD");
      // this.getDispatchConfig();
      // this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    async pastDue() {
      if (!this.$refs.form.validate()) {
        return false;
      }

      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure you want to confirm this application?"
        )
      ) {
        this.loadingBtn = true;
        this.form.installationDate = `${this.installationDate} ${this.installationTime}`;

        await this.$api
          .post("/online/cod/confirm", this.form)
          .then((response) => {
            const res = response.data;
            console.log(res);

            if (!res.status) {
              this.loadingBtn = false;
              this.$store.dispatch("addSnackbarMessage", res.message);
              this.$store.dispatch("addSnackbar", true);
              return;
            }

            this.loadingBtn = false;
            // this.$refs.form.reset();
            this.$store.dispatch(
              "addSnackbarMessage",
              "Successfully submitted."
            );
            this.$store.dispatch("addSnackbar", true);
            this.agree();
          })
          .catch((e) => {
            console.log(e);
            this.loadingBtn = false;
          });
      }
    },

    async onSubmit() {
      if (!this.$refs.form.validate()) {
        return false;
      }

      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure you want to confirm this application?"
        )
      ) {
        this.loadingBtn = true;
        this.form.installationDate = `${this.installationDate} ${this.installationTime}`;

        await this.$api
          .post("/online/cod/confirm", this.form)
          .then((response) => {
            const res = response.data;
            console.log(res);

            if (!res.status) {
              this.loadingBtn = false;
              this.$store.dispatch("addSnackbarMessage", res.message);
              this.$store.dispatch("addSnackbar", true);
              return;
            }

            this.loadingBtn = false;
            // this.$refs.form.reset();
            this.$store.dispatch(
              "addSnackbarMessage",
              "Successfully submitted."
            );
            this.$store.dispatch("addSnackbar", true);
            this.agree();
          })
          .catch((e) => {
            console.log(e);
            this.loadingBtn = false;
          });
      }
    },

    agree() {
      this.resolve(true);
      this.dialog = false;
    },

    cancel() {
      this.resolve(false);
      this.dialog = false;
    },

    async onCancel() {
      const cancelReason = await this.$refs.codCancel.open();
      console.log(cancelReason);

      if (cancelReason.status) {
        if (
          await this.$refs.confirm.open(
            "Confirm",
            "Are you sure you want to cancel this application?"
          )
        ) {
          this.loadingBtn = true;
          await this.$api
            .post("/online/cod/cancel", {
              referenceNumber: this.selectedData.referenceNumber,
              reason: cancelReason.reason,
            })
            .then((response) => {
              const res = response.data;
              this.loadingBtn = false;
              console.log(res);
              if (!res.status) {
                this.loadingBtn = false;
                this.$store.dispatch("addSnackbarMessage", res.messge);
                this.$store.dispatch("addSnackbar", true);
                return;
              }
              this.loadingBtn = false;
              this.$refs.form.reset();
              this.$store.dispatch("addSnackbarMessage", res.message);
              this.$store.dispatch("addSnackbar", true);
              this.agree();
            })
            .catch((e) => {
              console.log(e);
              this.loadingBtn = false;
            });
        }
      }
    },


    async showNextCalldate() {
      const response = await this.$refs.nextCallDate.open();
      console.log(response)

      if(response.status){
        if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure you want to update next call date?"
        )
      ) {
        const payload = {
          referenceNumber: this.form.referenceNumber,
          nextCallDate: response.data.date,
          reason: response.data.reason
        };
        await this.$api
          .post("/online/cod/next-call-date", payload)
          .then((response) => {
            const res = response.data;
            console.log(res);

            if (!res.status) {
              this.loadingBtn = false;
              this.$store.dispatch("addSnackbarMessage", res.message);
              this.$store.dispatch("addSnackbar", true);
              return;
            }

            this.loadingBtn = false;
            // this.$refs.form.reset();
            this.$store.dispatch("addSnackbarMessage", res.message);
            this.$store.dispatch("addSnackbar", true);
            this.agree();
          })
          .catch((e) => {
            console.log(e);
            this.loadingBtn = false;
          });
      }
      }
    },
  },

  created() {},
};
</script>

<style scoped>
.images > img {
  cursor: pointer;
}
</style>
